/**
 * Human-readable lines from AT packet API `notificationEvents` (email + internal inbox outcomes).
 * Used after PATCH create/update and POST create (passed through navigation state).
 */
export function summarizeAtPacketNotificationEvents(events) {
  if (!Array.isArray(events) || events.length === 0) return null;
  const lines = [];
  for (const ev of events) {
    if (!ev || typeof ev !== 'object') continue;
    const { channel, status, reason } = ev;
    const reasonText = reason != null && String(reason).trim() ? String(reason).trim() : '';
    if (channel === 'external_email') {
      if (status === 'sent') {
        const n = ev.recipientCount;
        const r =
          typeof n === 'number'
            ? `${n} recipient${n === 1 ? '' : 's'}`
            : 'recipients';
        lines.push(`Email sent (${r}).`);
      } else if (status === 'preview') {
        lines.push('External email is ready to review — use the dialog to send or cancel.');
      } else {
        lines.push(reasonText ? `Email not sent: ${reasonText}` : 'Email not sent.');
      }
    } else if (channel === 'internal_inbox') {
      if (status === 'sent') {
        const hint =
          ev.recipientKind === 'at_coordinator'
            ? "Internal notification sent to the tenant AT coordinator's inbox."
            : "Internal notification sent to the service coordinator's inbox.";
        lines.push(hint);
      } else {
        lines.push(
          reasonText ? `Internal notification not sent: ${reasonText}` : 'Internal notification not sent.'
        );
      }
    }
  }
  return lines.length > 0 ? lines.join('\n') : null;
}
